/**
 * Parses salesforce api value to string matching portal translation id.
 * @function
 * @category Translation
 * @param {string} apiValue Salesforce api value string.
 * @param {string} [prefix=''] String that will be added to the begining of returned string.
 * @returns {string} String matching portal translation id.
 */
export function parseSFApiValueToTranslationId (apiValue, prefix = '') {
  const toRet = String(apiValue)
    .toUpperCase()
    .replaceAll(' - ', ' ')
    .replace(/\s+/g, '_')
  return prefix ? `${prefix}_${toRet}` : toRet
}
